import { Styles } from '@typings/common';

export const slimCell: Styles = {
  p: '0.25rem',
  width: '1px',
};
